import { makeStyles } from "@material-ui/core/styles";

export const useCreateStyles = makeStyles({
  root: { alignItems: "flex-start" },

  box: {
    width: "100%",
  },
  grid: {
    width: "100%",
  },
  textInput: {
    width: "auto",
  },
});
